export default "__VITE_ASSET__BKK5BVlV__"